<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Registra y controla pagos de clientes. 
                Permite ingresar cobros, aplicar abonos 
                a facturas y ver saldos pendientes. Úsalo 
                para mantener al día las cuentas y evitar moras.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Cobranzas
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Lista, procesa y sincroniza los <b>cobros</b> generados en los <b>socios de negocio</b> de forma individual
          y/o bloque.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">

          <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
            [showStatus]="[0,6,7,8]" [showERPStatus]="[4,1,0,3]" [typeFilter]="'Charges'" (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Reporte de Visitas</div> -->
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMenu">
              <span>Estados</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusERPMenu">
              <span>Estados ERP</span>
            </button>
          </mat-menu>

          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(141, 19, 19)"></mat-icon>
              <span>Anulado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:play-circle" style="color:rgb(236, 199, 58)"></mat-icon>
              <span>En progreso</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Aceptado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Rechazado</span>
            </button>
          </mat-menu>
          <mat-menu #statusERPMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Error en ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-up" style="color:rgb(65, 106, 218)"></mat-icon>
              <span>Enviado a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(233, 124, 61)"></mat-icon>
              <span>Pendiente envío a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-check" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Creado en ERP</span>
            </button>
          </mat-menu>

        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Sincronizar" matTooltip="Sincronizar"
            (click)="synchronizeOrders(null)"
            [disabled]="!isGlobalSynchronizeAvailable">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <!-- <div class="w-full mt-2" *ngIf="selectedStatuses.length > 0 || selectedERPStatuses.length > 0">
        <div class="flex flex-wrap gap-2 w-full">

          <mat-chip *ngFor="let status of getSelectedStatusObjects()" [removable]="true" (removed)="removeSelection(status.value)"
            class="h-8 min-h-8 rounded-full px-3 text-xs font-medium flex items-center
                          bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors
                          mr-1.5 mb-1.5">
            <span class="text-xs font-medium">{{status.label}}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
    
          <mat-chip *ngFor="let status of getSelectedERPStatusObjects()" [removable]="true"
            (removed)="removeERPSelection(status.value)" 
                    class="h-8 min-h-8 rounded-full px-3 text-xs font-medium flex items-center
                          bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors
                          mr-1.5 mb-1.5">
            <span class="text-xs font-medium">{{status.label}}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </div>
      </div> -->
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button (click)="toggleDetails(element)" style="margin-left: 10px">
                    <mat-icon class="icon-size-5" [svgIcon]="
                      selectedPay?.trip?._id === element?.trip?._id
                        ? 'heroicons_solid:chevron-up'
                        : 'heroicons_solid:chevron-down'
                    "></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="doc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <button mat-icon-button (click)="downloadReport(element)" matTooltip="Descargar Reporte">
                    <mat-icon svgIcon="excel"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="map">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <button mat-icon-button (click)="openModal(element, 'H')" color="primary" matTooltip="Ver mapa">
                    <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="trip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Viaje
                </th>
                <td mat-cell *matCellDef="let element" class="text-secondary text-left first-col table-text">
                  <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': element?.trip?.id }"
                    (click)="element?.trip?.id && goToTravel(element)"
                    [matTooltip]="element?.trip.id ? 'Ir al viaje' : ''">
                    <span>{{ element?.trip?.id ? element.trip.id : '-' }}</span>
                    <mat-icon *ngIf="element?.trip.id" class="ml-2 icon-size-3 hover:animate-bounce"
                      [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="routeUser">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Ruta - Usuario
                </th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <app-user-route-display
                    [routeData]="{
                      routeName: element?.subRoute?.name ?? '-',
                      externalKeys: { code: getCode(element?.subRoute) ?? '-' }
                    }"
                    [userData]="{name: element?.user ?? element?.user?.user_login?.username ?? '-' }"
                    [responsibleData]="{name: element?.responsibleBusinessPartner?.name ?? '-', personNumber: element?.responsibleBusinessPartner?.personNumber ?? '-', externalKeys: { code: element?.responsibleBusinessPartner?.externalKeys?.code ?? '-' }}"
                    [displayMode]="'detailed'"
                    [showRouteCode]="true"
                    [showUser]="true"
                    [showResponsible]="true">
                  </app-user-route-display>
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Fecha
                </th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <div class="text-content">
                    <span class="font-descrip">{{
                      element?.trip?.dateHourStart | date:"dd-MM-yyyy" }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="documents_count">
                <th mat-header-cell *matHeaderCellDef class="text-center first-col table-tittle" arrowPosition="before">
                  Cantidad<br>Documentos
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m">
                    {{ element?.documents_count }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="totalPayingAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                  class="text-right first-col table-tittle w-min-detail-b" arrowPosition="before">
                  Recaudado {{ 'code' | companyCurrency: true }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-right first-col table-text ">
                  <p class="table-text-m">
                    <!-- <span class="table-text-code">{{ element?.class?.externalKeys?.code }}</span><br> -->
                    {{ element?.totalPayingAmount | moneda }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="totalPayingRealAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"
                  arrowPosition="before">
                  Pago <br> Aceptado {{ 'code' | companyCurrency: true }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-right first-col table-text ">
                  <p class="table-text-m">
                    {{ element?.totalPayingRealAmount | moneda }}
                    <!-- <b>C: </b>{{formatDate(element.loadDateTime)}}<br> -->
                    <!-- <b>E: </b>{{formatDate(element.deliveryDateTime)}} -->
                  </p>
                </td>
              </ng-container>

              <ng-container matColumnDef="totalPayingEfectiveAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right first-col table-tittle "
                  arrowPosition="before">
                  Pago<br> Rechazado {{ 'code' | companyCurrency: true }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-right first-col table-text">
                  <p class="table-text-m">
                    {{ element?.totalPaymentReviewCountSend | moneda}}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="amountNotVerified">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"
                  arrowPosition="before">
                  <span style="text-align: left">Pago Sin<br>Verificar  {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="text-right first-col table-text">
                  <p class="table-text-m">
                    {{ element?.amountNotVerified | moneda }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentReviewPercentage">
                <th mat-header-cell *matHeaderCellDef class="text-center first-col table-tittle">
                  <!-- <span class="table-text-m-2">% de Avance<br>Revisión</span> -->
                  % <br> Revisión
                </th>
                <td mat-cell *matCellDef="let element" class="text-center first-col table-text">
                  <p class="table-text-m">
                    {{ element?.paymentReviewPercentage | number: "1.2-2" }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentReviewPercentageERP">
                <th mat-header-cell *matHeaderCellDef class="text-center first-col table-tittle">
                  <span class="table-text-m-2">% <br>Envío</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-center">
                  <p class="table-text-m">
                    {{ element?.paymentReviewPercentageERP | number: "1.2-2" }}
                  </p>
                </td>
              </ng-container>

              <!-- <ng-container matColumnDef="durationRoute">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Duración <br> Ruta</th>
                          <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                              {{element?.totalRouteDurationHours | FormatToHour}}
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="efectivityTime">
                          <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle">Tiempo <br> Efectivo</th>
                          <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                              {{element?.totalVisitDurationHours | FormatToHour}}
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="durationTrip">
                          <th mat-header-cell *matHeaderCellDef class=" text-center first-col table-tittle">Duración<br>Viaje</th>
                          <td mat-cell *matCellDef="let element" class=" text-right first-col table-text">
                                 <b>Estimado:</b>{{element?.tripDurationHoursTeoric | FormatToHour}}<br>
                                 <b>Real:</b>{{element?.tripDurationHours | FormatToHour}}</td>
                      </ng-container>                 -->

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <tr *ngIf="selectedPay?.trip?._id === element?.trip?._id" class="details-row">
                    <td [attr.colspan]="displayedColumns.length">
                      <ng-container *ngTemplateOutlet="
                      rowDetailsTemplate;
                        context: { $implicit: row }
                      "></ng-container>
                    </td>
                  </tr>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let element; columns: displayedColumns; when: isMainRow" class="border-b"
                [class.table-expanded-row]="
                selectedPay?.trip?._id === element?.trip?._id
              "></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
            Lo sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
    <!-- Modales -->
  </div>
  <ng-template #rowDetailsTemplate let-order>
    <div class="overflow-hidden">
      <div class="flex border-b">
        <form class="flex w-full flex-col">
          <div class="flex flex-col py-6 px-13 sm:flex-row">
            <div class="flex flex-auto flex-wrap">
              <div class="p-2 flex w-full flex-col">
                <table class="w-width min-w-500 overflow-y-visible mat-elevation-z" mat-table
                  [dataSource]="dataSourceDetail" matSort multiTemplateDataRows>
                  <ng-container matColumnDef="expandable">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle w-min-detail-b">
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text">
                      <button mat-icon-button (click)="toggleRow(detail)" style="margin-left: 10px">
                        <mat-icon class="icon-size-5" [svgIcon]="
                          selectedDetail?.serials === detail?.serials
                            ? 'heroicons_solid:chevron-up'
                            : 'heroicons_solid:chevron-down'
                        "></mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef class="px-6  first-col table-tittle w-min-detail">
                      <mat-checkbox color="primary" (change)="$event ? masterToggle() : null; onCheckboxChange($event)"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text">
                      <mat-checkbox color="primary" (click)="$event.stopPropagation(); onCheckboxChange($event, detail)"
                        (change)="$event ? selection.toggle(detail) : null;" [checked]="selection.isSelected(detail)"
                        [aria-label]="checkboxLabel(detail)" [disabled]="!(
                              validateDataToSynchronize(detail)
                            )">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="paymentImages">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-left first-col table-tittle w-min-detail">
                      <span class="table-text-m-2"></span>
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                      <mat-icon color="primary" matBadge="{{ detail?.paymentImages?.length || 0 }}" [matTooltip]="
                          detail?.paymentImages?.length > 0
                            ? 'Ver imágenes'
                            : 'Sin imágenes'
                        " class="pointer-icon"
                        (click)="detail?.paymentImages.length > 0 ? openImageCarousel(detail.paymentImages) : null"
                        matBadgeColor="accent" matBadgeSize="small" aria-hidden="false">photo_library</mat-icon>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-left first-col table-tittle w-min-detail"></th>
                    <td mat-cell *matCellDef="let element" class=" px-6 text-center first-col table-text">
                      <mat-icon *ngIf="element.paymentReview == 6" svgIcon="heroicons_solid:play-circle"
                        matTooltip="En progreso" style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="element.paymentReview == 7" svgIcon="heroicons_solid:check-circle"
                        matTooltip="Aceptado" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="element.paymentReview == 8" svgIcon="heroicons_solid:x-circle"
                        matTooltip="Rechazado" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="payment_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-left first-col table-tittle w-min-detail"></th>
                    <td mat-cell *matCellDef="let element" class=" px-6 text-center first-col table-text">
                      <mat-icon *ngIf="element.paymentStatus == 0" svgIcon="heroicons_solid:clock"
                        matTooltip="Pendiente envío a ERP" style="color:rgb(233, 124, 61); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="element.paymentStatus == 1" svgIcon="heroicons_solid:document-arrow-up"
                        matTooltip="Enviado a ERP" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="element.paymentStatus == 3" svgIcon="heroicons_solid:document-check"
                        matTooltip="Creado en ERP" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="element.paymentStatus == 4" svgIcon="heroicons_solid:exclamation-triangle"
                        matTooltip="Error en ERP" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="paymentReview">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-left first-col table-tittle w-min-detail">
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                      <button mat-icon-button color="primary" matTooltip="{{ detail.commentary }}" [disabled]="
                        !(detail.commentary && detail.commentary != '')
                      ">
                        <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="shipTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Socio de Negocio
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m text-uppercase" style="min-width: 102px;">
                        <span class="table-text-code">{{
                          detail?.shipToExternalKeyCode
                          }}</span><br />
                        {{ detail?.shipToName }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="serial">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Nro.Doc. Pago
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m">{{
                        detail?.serials
                        }}
                      </p>
                    </td>
                  </ng-container>
                  <!-- <ng-container matColumnDef="paymentMethod">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                    Doc.<br>/Tipo Pago
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                    <span class="table-text-code">{{
                      detail.serials &&
                      detail.serials.trim() !== "" &&
                      detail.serials !== "null"
                        ? detail.serials
                        : ""
                    }}</span><br>
                      {{ detail.paymentMethod }}-{{ detail.paymentType }}
                    </td>
                  </ng-container> -->
                  <ng-container matColumnDef="dateHour">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Fecha y Hora
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      {{ detail?.dateHour | FormatDateHour: true }}
                    </td>
                  </ng-container>
                  <!-- <ng-container matColumnDef="bankOperation">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left first-col table-tittle"
                    >
                      Nro. Letra
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                    <span class="table-text-code">{{
                      detail?.bankOperation
                    }}</span><br>
                    {{ detail?.bankOperationNumber }}
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="bank">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-center first-col table-tittle"
                    >
                      Banco
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                    <span class="table-text-code">{{
                      detail?.bank
                    }}</span><br>
                      {{ detail.accountNumber }}
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="operationNumber">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-right first-col table-tittle"
                    >
                      Operación
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-left first-col table-text"
                    >
                      <p class="table-text-m text-left">
                        {{ detail?.operationNumber ? detail.operationNumber : "" }}
                      </p>
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="comment">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="px-6 text-left first-col table-tittle"
                      style="width: 90px;"
                    >
                      Comentario
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                        matTooltip="{{ detail.comment }}"
                    >
                        {{ detail.comment | slice:0:10 }}{{ detail?.comment? detail.comment.length > 10 ? '...' : '':'' }}
                    </td>
                  </ng-container> -->
                  <ng-container matColumnDef="totalAmount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-right first-col table-tittle"
                      arrowPosition="before">
                      Total Recibido ({{this.currency}})
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-right first-col table-text">
                      {{ detail.totalAmount | moneda }}
                    </td>
                  </ng-container>
                  <!-- <ng-container matColumnDef="pendingPayment">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-right first-col table-tittle"
                      arrowPosition="before"
                    >
                    Pago Pendiente
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-right first-col table-text"
                    >
                      {{ detail.pendingPayment | moneda }}
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="paying">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-right first-col table-tittle"
                      arrowPosition="before"
                    >
                      Abono
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-right first-col table-text"
                    >
                      {{ detail.paying | moneda }}
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="balance">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-right first-col table-tittle"
                      arrowPosition="before"
                    >
                      Saldo
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let detail"
                      class="px-6 text-right first-col table-text"
                    >
                      {{ detail.balance | moneda }}
                    </td>
                  </ng-container> -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="text-center first-col" style="min-width: 40px"></th>
                    <td mat-cell *matCellDef="let detail" class="text-center first-col">
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #actionMenu="matMenu">
                        <button  mat-menu-item
                          (click)="synchronizeOrders(detail)" [disabled]="!(
                                    validateDataToSynchronize(detail)
                                  )">
                          <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                          <span>Sincronizar</span>
                        </button>
                        <button mat-menu-item (click)="openLogModal(detail)">
                          <mat-icon>visibility</mat-icon>
                          <span>Visualizar logs</span>
                        </button>
                        <button 
                          mat-menu-item (click)="openModal(detail)" [disabled]="!(validateDataToAppOrRejected(detail))">
                          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                          <span>Aprobar/Rechazar</span>
                        </button>
                        <button mat-menu-item (click)="printCollection(detail)"
                          matTooltip="Imprimir cobranza">
                          <mat-icon>print</mat-icon>
                          <span>Imprimir cobranza</span>
                        </button>
                      </mat-menu>
                    </td>
                  </ng-container>

                  <!-- Fila de detalles (siempre visible) -->
                  <ng-container matColumnDef="expanded">
                    <td mat-cell *matCellDef="let detail" [attr.colspan]="displayedColumnsDetail.length">
                      <tr *ngIf="selectedDetail?.serials === detail.serials" class="details-row">
                        <td [attr.colspan]="displayedColumnsDetail.length">
                          <ng-container *ngTemplateOutlet="
           nestedTableTemplate;
            context: { $implicit: row }
          "></ng-container>
                        </td>
                      </tr>
                    </td>
                  </ng-container>

                  <!-- Cabeceras -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                  <!-- Filas principales -->
                  <tr mat-row *matRowDef="let detail; columns: displayedColumnsDetail;" class="border-b"
                    [class.table-expanded-row]="
  selectedDetail?.serials === detail.serials
"></tr>

                  <!-- Filas de detalles -->
                  <tr mat-row *matRowDef="let row; columns: ['expanded']" class="table-detail-row"></tr>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #noData>
    <span> - </span>
  </ng-template>

  <ng-template #nestedTableTemplate>
    <mat-tab-group>
      <!-- Primer Tab con la primera tabla -->
      <mat-tab label="Métodos de Pago">
        <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">
                  <div class="p-2 flex w-full flex-col"> -->
        <table mat-table [dataSource]="dataSourceInnerDetail"
          class="w-width min-w-500 overflow-y-visible mat-elevation-z" multiTemplateDataRows style="margin-top: 5px">
          <ng-container matColumnDef="paymentMethod">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
              Tipo Pago
            </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
              <p class="table-text-m">{{
                innerDetail.paymentType
                }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="bank">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
              Banco
            </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
              <span class="table-text-code">{{
                innerDetail?.bank
                }}</span><br>
              {{ innerDetail.accountNumber }}
            </td>
          </ng-container>


          <ng-container matColumnDef="inner">
            <th mat-header-cell *matHeaderCellDef class="px-6  first-col table-tittle w-min-detail-b"></th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center first-col table-text">
              <button mat-icon-button (click)="toggleInner(innerDetail)" style="margin-left: 10px">
                <mat-icon class="icon-size-5" [svgIcon]="
                            selectedInner?.id === innerDetail?.id
                              ? 'heroicons_solid:chevron-up'
                              : 'heroicons_solid:chevron-down'
                          "></mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="operationNumber">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-center first-col table-tittle"> N.Operacion </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center first-col table-text"> {{
              innerDetail.operationNumber }} </td>
          </ng-container>


          <ng-container matColumnDef="paying">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle"> Abono
              ({{this.currency}}) </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text">{{
              innerDetail.paying | moneda }} </td>
          </ng-container>

          <!-- Fila de detalles (siempre visible) -->
          <ng-container matColumnDef="expanded">
            <td mat-cell *matCellDef="let detail" [attr.colspan]="displayedColumnsInnerDetail.length">
              <tr *ngIf="selectedInner?.id === detail.id" class="details-row">
                <td [attr.colspan]="displayedColumnsInnerDetail.length">
                  <ng-container *ngTemplateOutlet="
           nestedTableTemplateInner;
            context: { $implicit: row }
          "></ng-container>
                </td>
              </tr>
            </td>
          </ng-container>

          <!-- Cabeceras -->
          <tr mat-header-row *matHeaderRowDef="displayedColumnsInnerDetail"
            class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
          <!-- Filas principales -->
          <tr mat-row *matRowDef="let detail; columns: displayedColumnsInnerDetail;" class="border-b"
            [class.table-expanded-row]="
  selectedInner?.id === detail.id
"></tr>

          <!-- Filas de detalles -->
          <tr mat-row *matRowDef="let row; columns: ['expanded']" class="table-detail-row"></tr>
        </table>
        <!-- </div>
                </div>
              </div>
            </form>
          </div>
        </div> -->
      </mat-tab>

      <!-- Segundo Tab con la segunda tabla -->
      <mat-tab label="Documentos">
        <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">
                  <div class="p-1 flex w-full flex-col">-->
        <table mat-table [dataSource]="dataSourceDocument" class="w-width min-w-500 overflow-y-visible mat-elevation-z"
          style="padding-top: 5px">
          <ng-container matColumnDef="serials">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle"> #Pago</th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center table-text"> {{ innerDetail.serials }}
            </td>
          </ng-container>

          <ng-container matColumnDef="paymentType">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle"> Tipo </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center table-text"> {{ innerDetail.documentType
              }} </td>
          </ng-container>

          <ng-container matColumnDef="document">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle"> Nro. Documento </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center table-text"> {{ innerDetail.document }}
            </td>
          </ng-container>

          <ng-container matColumnDef="afecto">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle"> Doc. Afecto </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center table-text">
              <ng-container *ngIf="innerDetail.paymentType.code === 'TP0006'">
                {{ innerDetail.creditNoteNumber }}
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="pendingPayment">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-right table-tittle"> Adeudado ({{this.currency}})
            </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right table-text"> {{ innerDetail.amount
              | moneda }} </td>
          </ng-container>

          <ng-container matColumnDef="paying">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle"> Abono
              ({{this.currency}}) </th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text"> {{
              innerDetail.paying | moneda }} </td>
          </ng-container>

          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle"> Saldo
              ({{this.currency}})</th>
            <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text"> {{
              innerDetail.balance | moneda}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsDocument"
            class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
          <tr mat-row *matRowDef="let innerDetail; columns: displayedColumnsDocument"></tr>
        </table>
        <!--   </div>
                </div>
              </div>
            </form>
          </div>
        </div> -->
      </mat-tab>
    </mat-tab-group>

  </ng-template>

  <ng-template #nestedTableTemplateInner>
    <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">-->
    <!-- <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">  -->
    <!-- <div class="pl-13 flex w-full flex-col "> -->
    <div class="p-1 pl-13 flex w-full flex-col ">
      <table mat-table [dataSource]="dataSourceShip" class="w-width min-w-500 overflow-y-visible mat-elevation-z"
        multiTemplateDataRows>
        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
            Tipo
          </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
            <p class="table-text-m">{{
              innerDetail?.documentType
              }}
            </p>
          </td>
        </ng-container>


        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-center first-col table-tittle"> Nro. Documento </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center first-col table-text"> {{
            innerDetail.document }} </td>
        </ng-container>


        <ng-container matColumnDef="paying">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right first-col table-tittle"> Abono
            ({{this.currency}}) </th>
          <td mat-cell *matCellDef="let innerDetail" class="px-6 text-right first-col table-text">{{ innerDetail.paying
            | moneda }} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumnsShip" class="sticky top-0 z-10  bg-white dark:bg-gray-900">
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsShip;"></tr>
      </table>
    </div>
    <!-- </div>
              </div> -->
    <!--</form>
          </div>
        </div> -->
  </ng-template>

  <ng-template #collectionPdfDialog let-dialogRef="dialogRef">
    <form [formGroup]="collectionForm" class="p-6 w-full">
      <h2 class="text-lg font-semibold mb-4">Descargar cobranza</h2>
      <mat-form-field *ngIf="selectedElement?.shipDetail?.length > 1" appearance="fill" class="w-full mb-4">
        <mat-label>Modo de impresión</mat-label>
        <mat-select formControlName="printMode" required>
          <mat-option  *ngFor="let mode of cobranzaPrintModes" [value]="mode.value">{{ mode.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Cobranza</mat-label>
        <mat-select formControlName="collectionId" placeholder="Selecciona una cobranza" required>
          <mat-option
            *ngFor="let detail of selectedElement?.shipDetail"
            [value]="detail.id">
             {{ detail.paymentType }} | Monto: {{ detail.totalAmount }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="collectionForm.get('collectionId')?.hasError('required')">
          Debes seleccionar una cobranza
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full mb-4">
        <mat-label>Orientación del PDF</mat-label>
        <mat-select formControlName="landscape" required>
          <mat-option [value]="false">Vertical</mat-option>
          <mat-option [value]="true">Horizontal</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="mt-4 flex justify-between space-x-2">
        <button mat-button (click)="dialogRef.close()">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="collectionForm.invalid"
          (click)="downloadCollection(); dialogRef.close()">
          Descargar
        </button>
      </div>
    </form>
  </ng-template>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()">

    <app-filter-section title="Rango de Fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true" [showEndTrip]="true"/>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters
        [form]="form"
        [companyWithMongoId]="true"
        [loadData]="loadConfigData"
      ></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters
          [form]="form"
          [route]="true"
          [loadData]="loadRoutesData"
        ></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socios de Negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters
        [form]="form"
        [businessPartner]="true"
        [loadData]="loadBusinessPartnersData"
      ></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Finanzas" [expanded]="false" (onExpanded)="onFinanceExpanded()">
      <app-finance-filters
        [form]="form"
        [paymentMethodList]="paymentMethodFilterList"
        [paymentTypeList]="paymentTypeList"
        [bankList]="bankList"
      ></app-finance-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>